import { Checkbox, Label } from '@fluentui/react';

import { Product } from '../../../slice/newFormReducers';
import { useColumnOnChangeFn, useColumnSelector } from './hooks';

type Props = {
  uuid: string;
};

const key: keyof Product = "isShipped";

export default ({ uuid }: Props) => {
  const value = useColumnSelector(uuid, key);
  const onChange = useColumnOnChangeFn(uuid, key, true);

  if (value === undefined) {
    return <Label>- Bilinemez -</Label>;
  } else {
    return (
      <Checkbox
        checked={value}
        onChange={onChange}
        label={value ? "Edildi" : "Edilmedi"}
      />
    );
  }
};
